export default __webpack_public_path__ + "static/media/omar.e6a2ea82.png";